import {Capacitor, registerPlugin} from '@capacitor/core';
import {isStagingEnvironment} from '../auth/native-auth-config';
import {PushNativePlugin} from './push-native-plugin';

const native = registerPlugin<PushNativePlugin>('InvemoryPush');
export const PushNative: PushNativePlugin = {
  setBinding: options => native.setBinding(options),
  clearBinding: () => native.clearBinding(),
  takeTap: () => native.takeTap(),
  openSettings: () => native.openSettings(),
  addListener: (event, listener) => native.addListener(event, listener),
};
export const isPushSupported = (): boolean => Capacitor.getPlatform() === 'android' && !isStagingEnvironment();
